export var ProductDimensionViewTypes;

(function (ProductDimensionViewTypes) {
  ProductDimensionViewTypes[ProductDimensionViewTypes["all"] = 0] = "all";
  ProductDimensionViewTypes[ProductDimensionViewTypes["door"] = 1] = "door";
  ProductDimensionViewTypes[ProductDimensionViewTypes["opening"] = 2] = "opening";
  ProductDimensionViewTypes[ProductDimensionViewTypes["track"] = 3] = "track";
  ProductDimensionViewTypes[ProductDimensionViewTypes["space_above"] = 4] = "space_above";
})(ProductDimensionViewTypes || (ProductDimensionViewTypes = {}));